import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

interface IMetaEvent {
  event_name: string
  event_time: number
  data: {
    event_name: string
    event_time: number
    user_data: {
      em: string
      ph: string
      client_ip_address: string
      client_user_agent: string
      ge: string
      fbc: string | null
      fn: string
    }
  }[]
}
const useMetaEventMutation = () => {
  const getMetaEvent = async (data: IMetaEvent) => {
    const resp = await axios.post(
      `https://graph.facebook.com/v22.0/526246818652568/events?access_token=${process.env.NEXT_PUBLIC_META_ACCESS_TOKEN}`,
      data,
    )
    return resp.data
  }

  const mutation = useMutation({ mutationFn: getMetaEvent })

  return mutation
}

export default useMetaEventMutation
